import React from "react";
import { t } from "../../i18n";
import serviceCarAccident from "../../assets/images/services/service-car-accident.webp";
import serviceOrthopedics from "../../assets/images/services/service-orthopedics.webp";
import servicePersonalInjury from "../../assets/images/services/service-personal-injury.webp";
import servicePhysicalTherapy from "../../assets/images/services/service-physical-therapy.webp";
import servicePainManagement from "../../assets/images/services/service-pain-management.webp";
import serviceNeurology from "../../assets/images/services/service-neurology.webp";
import serviceInjections from "../../assets/images/services/service-injections.webp";
import serviceMedicalClinic from "../../assets/images/services/service-medical-clinic.webp";
import serviceXray from "../../assets/images/services/service-xray.webp";
import "./ServiceDescription.css";

const SERVICE_IMAGES = {
  // ── Accident Recovery ──
  "car-accident-doctor": serviceCarAccident,
  "car-accident-treatment": serviceCarAccident,
  "truck-accident-doctor": serviceCarAccident,
  "truck-accident-treatment": serviceCarAccident,
  "motorcycle-accident-doctor": serviceCarAccident,
  "motorcycle-accident-treatment": serviceCarAccident,
  "uber-accident-injury-treatment": serviceCarAccident,
  "pedestrian-accident-treatment": servicePersonalInjury,
  "commercial-vehicle-accident-treatment": serviceCarAccident,
  "auto-accident-chiropractor": servicePhysicalTherapy,
  "slip-and-fall-doctor": servicePersonalInjury,
  // ── Workers' Comp & PI ──
  "workplace-injury-doctor": servicePersonalInjury,
  "workers-compensation-doctor": servicePersonalInjury,
  "workplace-injury-treatment": servicePersonalInjury,
  "work-injury": servicePersonalInjury,
  "personal-injury-doctor": servicePersonalInjury,
  "medical-documentation": serviceMedicalClinic,
  // ── Surgical ──
  "orthopedic-surgery": serviceOrthopedics,
  "endoscopic-spine-surgery": serviceOrthopedics,
  "endoscopic-rhizotomy": serviceOrthopedics,
  "spine-surgery": serviceOrthopedics,
  "back-surgery": serviceOrthopedics,
  "knee-surgery": serviceOrthopedics,
  "knee-replacement-surgery": serviceOrthopedics,
  "hip-replacement-surgery": serviceOrthopedics,
  "shoulder-surgery": serviceOrthopedics,
  "acl-surgery": serviceOrthopedics,
  // ── Rehabilitation ──
  "physical-therapy": servicePhysicalTherapy,
  "chiropractic-care": servicePhysicalTherapy,
  "sports-medicine": servicePhysicalTherapy,
  // ── Treatment ──
  "pain-management": servicePainManagement,
  "medical-injections": serviceInjections,
  "back-pain-treatment": servicePainManagement,
  "back-pain-treatments": servicePainManagement,
  "lower-back-pain-treatment": servicePainManagement,
  "knee-pain-treatment": serviceOrthopedics,
  "hip-pain-treatment": serviceOrthopedics,
  "shoulder-pain-treatment": serviceOrthopedics,
  "neck-pain-treatment": servicePainManagement,
  "joint-pain-treatment": serviceOrthopedics,
  "wrist-pain-treatment": serviceOrthopedics,
  "elbow-pain-treatment": serviceOrthopedics,
  "ankle-pain-treatment": serviceOrthopedics,
  "hand-injury-treatment": serviceOrthopedics,
  "rotator-cuff-treatment": serviceOrthopedics,
  "scoliosis-treatment": serviceOrthopedics,
  "spinal-cord-injury-treatment": serviceOrthopedics,
  "whiplash-treatment": serviceCarAccident,
  "whiplash-injury-clinic": serviceCarAccident,
  "whiplash-injury": serviceCarAccident,
  "broken-bones-treatment": serviceOrthopedics,
  "broken-bones": serviceOrthopedics,
  // ── Diagnostics & Spine ──
  "spine-care": serviceOrthopedics,
  "neurology": serviceNeurology,
  "mri": serviceXray,
  "x-ray-services": serviceXray,
  "medical-clinic": serviceMedicalClinic,
  "orthopedic-consultation": serviceOrthopedics,
};

export default function ServiceDescription({ service, location, locale = "en" }) {
  const serviceImg = SERVICE_IMAGES[service.slug] || serviceMedicalClinic;

  return (
    <section className="service-description">
      <div className="container">
        <h2>{t("section.ourApproach", locale, { service: service.display })}</h2>

        <div className="sd-grid">
          <div className="sd-content">
            <h3>{t("sd.whatIs", locale, { service: service.display })}</h3>
            <p>{t("sd.description", locale, { city: location.city, state: location.state, service: service.display.toLowerCase() })}</p>
            <p>{t("sd.description2", locale, { city: location.city })}</p>
          </div>
          <div className="sd-image">
            <img
              src={serviceImg}
              alt={`${service.display} treatment at our ${location.city} clinic`}
              className="sd-image-actual"
              loading="lazy"
            />
          </div>
        </div>

        <div className="sd-grid sd-grid-reverse">
          <div className="sd-image">
            <img
              src={serviceMedicalClinic}
              alt={`Our ${location.city}, ${location.state} medical facility`}
              className="sd-image-actual"
              loading="lazy"
            />
          </div>
          <div className="sd-content">
            <h3>{t("section.whyChooseUs", locale, { clientName: "Our Team" })}</h3>
            <ul className="sd-benefits">
              <li>✅ {t("sd.benefit.board", locale)}</li>
              <li>✅ {t("sd.benefit.sameDay", locale)}</li>
              <li>✅ {t("sd.benefit.freeConsult", locale)}</li>
              <li>✅ {t("sd.benefit.imaging", locale)}</li>
              <li>✅ {t("sd.benefit.bilingual", locale)}</li>
              <li>✅ {t("sd.benefit.location", locale, { city: location.city })}</li>
              <li>✅ {t("sd.benefit.legal", locale)}</li>
              <li>✅ {t("sd.benefit.comprehensive", locale)}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
